import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useAppLocale } from "./LocaleContext";
import { ratingsListCopyEn } from "@patient-watch/i18n/webapp/en-GB/ratingsListCopy";
import { ratingsListCopyDe } from "@patient-watch/i18n/webapp/de-DE/ratingsListCopy";
import { ratingsListCopyDa } from "@patient-watch/i18n/webapp/da-DK/ratingsListCopy";
import { ratingsListCopyEnUs } from "@patient-watch/i18n/webapp/en-US/ratingsListCopy";
import { ratingsListCopyFr } from "@patient-watch/i18n/webapp/fr-FR/ratingsListCopy";
import { ratingsListCopyIt } from "@patient-watch/i18n/webapp/it-IT/ratingsListCopy";
import { ratingsListCopyEs } from "@patient-watch/i18n/webapp/es-ES/ratingsListCopy";

interface RatingsListCopy {
    addActivityPlaceholder: (current: number, max: number) => string;
    add: string;
    emptyHint: string;
    noDifficulty: string;
    unableToDo: string;
    loading: string;
    loadError: string;
    noBaselineActivities: string;
    followUpHint: string;
}

const ratingsListCopy: Record<SupportedLocale, RatingsListCopy> = {
    "en-GB": ratingsListCopyEn,
    "en-US": ratingsListCopyEnUs,
    "de-DE": ratingsListCopyDe,
    "da-DK": ratingsListCopyDa,
    "fr-FR": ratingsListCopyFr,
    "it-IT": ratingsListCopyIt,
    "es-ES": ratingsListCopyEs,
};

export function useRatingsListCopy(): RatingsListCopy {
    const { locale } = useAppLocale();
    return pickAppCopy(ratingsListCopy, locale);
}
